import React from "react";
import "./partners.css";
import Heading from "../Heading";
import "animate.css/animate.min.css";
import ScrollAnimation from "react-animate-on-scroll";

const icon1 = "https://winpeforum.com/assets/elements/P3.png";
const icon3 = "https://winpeforum.com/assets/elements/cpdq-new.png";
const icon4 = "https://winpeforum.com/assets/elements/P5.png";
const icon5 = "https://winpeforum.com/assets/elements/P6.png";
const icon6 = "https://winpeforum.com/assets/elements/P2.png";
const icon7 = "https://winpeforum.com/assets/elements/P7.png";
const icon8 = "https://winpeforum.com/assets/elements/P4.png";
const icon9 = "https://winpeforum.com/assets/elements/Sequoia_edit_Logo.png";
const icon10 = "https://winpeforum.com/assets/elements/sidbi_logo.png";
const icon11 = "https://winpeforum.com/assets/elements/Multiples_Logo.png";
const icon12 = "https://winpeforum.com/assets/elements/warburg_pincus_logo.png";
const icon13 = "https://winpeforum.com/assets/elements/IVCA_Logo.png";
const icon14 = "https://winpeforum.com/assets/elements/MegaDelta_Logo.png";
const icon15 = "https://winpeforum.com/assets/elements/Truenorthlogo1.png";
const icon16 =
  "https://winpeforum.com/assets/elements/GeneralAtlantic_logo.jpg";
const icon17 = "https://winpeforum.com/assets/elements/kkr_logo1_250x250.png";
const icon18 = "https://winpeforum.com/assets/elements/Apax_Logo.png";
const icon19 = "https://winpeforum.com/assets/elements/postkalaari.png";
const icon20 = "https://winpeforum.com/assets/elements/paragon.png";
const icon21 =
  "https://winpeforum.com/assets/elements/RRA_Logo_Blue_RGB_PNG.png";
const icon22 = "https://winpeforum.com/assets/elements/Arpwood_250x250.png";
const icon23 = "https://winpeforum.com/assets/elements/UN_Women_logo.png";
const icon24 = "https://winpeforum.com/assets/elements/CDC_logo.png";
const icon25 =
  "https://winpeforum.com/assets/elements/Advent_International_Logo.png";
const icon26 = "https://winpeforum.com/assets/elements/Investcorp-logo.png";

const icon27 = "https://winpeforum.com/assets/elements/IronPillar_Logo-021.png";

const icon28 = "https://winpeforum.com/assets/BX_BORDER_RGB-01.png";
const icon29 = "https://winpeforum.com/assets/elements/ChrysCapital.png";
const icon30 = "https://winpeforum.com/assets/elements/cppib.png";
const icon31 = "https://winpeforum.com/assets/elements/SupplyChainLabs.png";
const icon32 = "https://winpeforum.com/assets/elements/menterra.png";

const icon33= "https://winpeforum.com/assets/elements/trifecta.png"
const icon34= "https://winpeforum.com/assets/elements/fidelis.png"
const icon35= "https://winpeforum.com/assets/elements/niif.png"
const icon36= "https://winpeforum.com/assets/elements/aavishkarcapital.png"
const icon37= "https://winpeforum.com/assets/elements/tpglogo.png"
const icon38= "https://winpeforum.com/assets/elements/BII.png"
const associatePartners = [
  {
    imgUrl: icon13,
    logoName: "partners logo",
    url: "https://ivca.in/",
  },
];

const knowledgePartners = [
  {
    imgUrl: icon21,
    logoName: "partners logo",
    url: "https://www.russellreynolds.com/",
  },
  {
    imgUrl: icon31,
    logoName: "partners logo",
    url: "https://supplychainlabs.in/",
  },
  {
    imgUrl: icon23,
    logoName: "partners logo",
    url: "https://www.unwomen.org/en",
  },
  
];

const foundingPartners = [
  {
    imgUrl: icon36,
    logoName: "partners logo",
    url: "https://aavishkaarcapital.in/",
  },
  {
    imgUrl: icon25,
    logoName: "partners logo",
    url: "https://www.adventinternational.com/",
  },
  {
    imgUrl: icon18,
    logoName: "partners logo",
    url: "https://www.apax.com/",
  },
  {
    imgUrl: icon22,
    logoName: "partners logo",
    url: "https://arpwood-partners.com/",
  },
  {
    imgUrl: icon1,
    logoName: "partners logo",
    url: "https://www.azbpartners.com/",
  },
  {
    imgUrl: icon6,
    logoName: "partners logo",
    url: "https://www.a91partners.com/",
  },
  {
    imgUrl: icon38,
    logoName: "partners logo",
    url: "https://www.bii.co.uk/en/",
  },
  {
    imgUrl: icon28,
    logoName: "partners logo",
    url: "https://www.blackstone.com/",
  },
   
  {
    imgUrl: icon3,
    logoName: "partners logo",
    url: "https://www.cdpq.com/en",
  },
  {
    imgUrl: icon29,
    logoName: "partners logo",
    url: "http://www.chryscapital.com/",
  },
  {
    imgUrl: icon30,
    logoName: "partners logo",
    url: "https://www.cppinvestments.com/",
  },
  {
    imgUrl: icon8,
    logoName: "partners logo",
    url: "https://www.everstonecapital.com/",
  },
  {
    imgUrl: icon34,
    logoName: "partners logo",
    url: "https://https://www.fidelisworld.com/",
  },
  {
    imgUrl: icon4,
    logoName: "partners logo",
    url: "http://www.gajacapital.com/",
  },
  {
    imgUrl: icon16,
    logoName: "partners logo",
    url: "https://www.generalatlantic.com/",
  },
  {
    imgUrl: icon26,
    logoName: "partners logo",
    url: "https://www.investcorp.com/",
  },
  {
    imgUrl: icon27,
    logoName: "Iron Pillar logo",
    url: "",
  },

 
  {
    imgUrl: icon17,
    logoName: "kkr logo",
    url: "https://www.kkr.com/",
  },
  {
    imgUrl: icon5,
    logoName: "partners logo",
    url: "http://www.lhfunds.com/",
  },
  {
    imgUrl: icon14,
    logoName: "partners logo",
    url: "http://www.megadeltacapital.com/",
  },
  {
        imgUrl: icon32,
        logoName: "partners logo",
        url: "https://www.menterra.com/",
  },
  {
    imgUrl: icon11,
    logoName: "partners logo",
    url: "http://www.multiplesequity.com/",
  },
  {
    imgUrl: icon35,
    logoName: "partners logo",
    url: "https://www.niifindia.in/",
  },
  {
    imgUrl: icon20,
    logoName: "partners logo",
    url: "http://www.paragonpartners.in/",
  },

  {
    imgUrl: icon9,
    logoName: "partners logo",
    url: "https://www.sequoiacap.com/india/",
  },
 
  {
    imgUrl: icon33,
    logoName: "partners logo",
    url: "https://trifectacapital.in/",
  },
  {
    imgUrl: icon7,
    logoName: "partners logo",
    url: "https://www.trilegal.com/",
  },
  {
    imgUrl: icon37,
    logoName: "partners logo",
    url: "https://tpg.com/",
  },
  {
    imgUrl: icon15,
    logoName: "partners logo",
    url: "https://truenorth.co.in/",
  },
  {
    imgUrl: icon12,
    logoName: "partners logo",
    url: "https://www.warburgpincus.com/",
  },
];

export class Partners extends React.Component {
  constructor(args) {
    super(args);
    this.state = {};

    this.foundingPartners = [];

    this.Partners = [
      {
        imgUrl: icon36,
        logoName: "partners logo",
        url: "https://aavishkaarcapital.in/",
      },
      {
        imgUrl: icon25,
        logoName: "partners logo",
        url: "https://www.adventinternational.com/",
      },
      {
        imgUrl: icon18,
        logoName: "partners logo",
        url: "https://www.apax.com/",
      },
      {
        imgUrl: icon22,
        logoName: "partners logo",
        url: "https://arpwood-partners.com/",
      },
      {
        imgUrl: icon1,
        logoName: "partners logo",
        url: "https://www.azbpartners.com/",
      },
      {
        imgUrl: icon6,
        logoName: "partners logo",
        url: "https://www.a91partners.com/",
      },
      {
        imgUrl: icon24,
        logoName: "partners logo",
        url: "https://www.cdcgroup.com/",
      },
      {
        imgUrl: icon3,
        logoName: "partners logo",
        url: "https://www.cdpq.com/en",
      },
      {
        imgUrl: icon8,
        logoName: "partners logo",
        url: "https://www.everstonecapital.com/",
      },
      {
        imgUrl: icon4,
        logoName: "partners logo",
        url: "http://www.gajacapital.com/",
      },
      {
        imgUrl: icon16,
        logoName: "partners logo",
        url: "https://www.generalatlantic.com/",
      },
      {
        imgUrl: icon26,
        logoName: "partners logo",
        url: "https://www.investcorp.com/",
      },
      {
        imgUrl: icon27,
        logoName: "Iron Pillar logo",
        url: "https://ironpillarfund.com/",
      },
      {
        imgUrl: icon13,
        logoName: "partners logo",
        url: "https://ivca.in/",
      },
      {
        imgUrl: icon19,
        logoName: "partners logo",
        url: "https://www.kalaari.com/",
      },
      {
        imgUrl: icon17,
        logoName: "kkr logo",
        url: "https://www.kkr.com/",
      },
      {
        imgUrl: icon5,
        logoName: "partners logo",
        url: "http://www.lhfunds.com/",
      },
      {
        imgUrl: icon14,
        logoName: "partners logo",
        url: "http://www.megadeltacapital.com/",
      },
      {
        imgUrl: icon32,
        logoName: "partners logo",
        url: "https://www.menterra.com/",
      },
      {
        imgUrl: icon11,
        logoName: "partners logo",
        url: "http://www.multiplesequity.com/",
      },
      {
        imgUrl: icon20,
        logoName: "partners logo",
        url: "http://www.paragonpartners.in/",
      },
      {
        imgUrl: icon21,
        logoName: "partners logo",
        url: "https://www.russellreynolds.com/",
      },
      {
        imgUrl: icon9,
        logoName: "partners logo",
        url: "https://www.sequoiacap.com/india/",
      },
   
      {
        imgUrl: icon7,
        logoName: "partners logo",
        url: "https://www.trilegal.com/",
      },
      {
        imgUrl: icon15,
        logoName: "partners logo",
        url: "https://truenorth.co.in/",
      },

      {
        imgUrl: icon12,
        logoName: "partners logo",
        url: "https://www.warburgpincus.com/",
      },
    ];
  }
  render() {
    return (
      <div className="section__content">
        <div className="partners__wrapper">
          <div className="partners__section">
            <div className="partners_content">
              <div className="low__heading"></div>
              <div className="">
                <Heading title="Partners in the cause" />
              </div>
              <ScrollAnimation
                delay={0}
                duration={3}
                animateIn="zoomIn"
                offset={300}
              >
                <div className="right_new_section">
                  <div className="right_content_new">
                    <div className="partners_logo_new">
                      <br />
                      <h3 className="partners-heading">
                        Winpe Founding Members
                      </h3>
                      <div className="row">
                   
                      {foundingPartners.map((item, i) => {
                           
                          if(i>=0 && i<28) 
                          {
                            return ( 
            
                              <div
                                className=" col-md-2 col-sm-12 col-xs-12 col-lg-2"
                                key={i}
                              >
                                <div className="p_card" style={{  marginLeft: '0%'}}>
                                  <a
                                    href={item.url}
                                    target="__blank"
                                    className=""
                                  >
                                    <img
                                      src={item.imgUrl}
                                      alt={item.logoName}
                                      className="img-responsive"
                                      style={{width:'260px' }}
                                    />
                                  </a>
                                </div>
                              </div>
                            );
                          }     
                           if(i==28) 
                           {
                            return ( 
                              <div
                              className="col-sm-12 col-xs-12 col-lg-2 col-md-2  "
                              key={i}
                            >
                              
                                <div className="p_card" style={{  marginRight: '0%'}}>
                                  <a
                                    href={item.url}
                                    target="__blank"
                                    className=""
                                  >
                                    <img
                                      src={item.imgUrl}
                                      alt={item.logoName}
                                      className="img-responsive"
                                       
                                    />
                                  </a>
                                </div>
                              </div>  
                            );
                           }     
                          
                          return ( 
            
                            <div
                              className="col-md-2 col-sm-12 col-xs-12 col-lg-2"
                              key={i}
                            >
                              <div className="p_card">
                                <a
                                  href={item.url}
                                  target="__blank"
                                  className=""
                                >
                                  <img
                                    src={item.imgUrl}
                                    alt={item.logoName}
                                    className="img-responsive"
                                  />
                                </a>
                              </div>
                            </div>
                          );
                        })}
                      </div>

                      <br />

                      <div className="row">
                        <div className="col col-12 col-lg-3">
                          <h3 className="partners-heading">
                            Associate Partner
                          </h3>
                          <div className="row">  
                            {associatePartners.map((item, i) => {
                              return (
                               <div className="col-12  " key={i}>
                                  <div className="p_card">
                                    <a 
                                      href={item.url}
                                      target="__blank"
                                      className=""
                                    >
                                      <img
                                        src={item.imgUrl}
                                        alt={item.logoName}
                                        className="img-responsive apartner-img" style={{maxWidth: '280px'}}npm 
                                      />
                                    </a>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>

                        <div className="col col-12 col-lg-9">
                          <h3 className="partners-heading">
                            Knowledge Partners
                          </h3>
                          <div className="row">
                            {knowledgePartners.map((item, i) => {
                              return (
                                <div className="col-12 col-md-4" key={i}>
                                  <div className="p_card">
                                    <a
                                      href={item.url}
                                      target="__blank"
                                      className=""
                                    >
                                      <img
                                        src={item.imgUrl}
                                        alt={item.logoName}
                                        className="img-responsive kpartners-img" style={{maxWidth: '250px'}}
                                      />
                                    </a>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ScrollAnimation>
            </div>
          </div>
          <div className="section_divider">
            <img
              src="https://winpeforum.com/assets/elements/phone_section_divider.png"
              width="100%"
              alt="Section_divier_gray"
              className="img-responsive"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Partners;



// WEBPACK FOOTER //
// ./src/components/partners/index.js